import React, { useState, createContext } from "react";
import channelData from "./ChannelData";

export const ChannelContext = createContext();

export const ChannelContextProvider = (props) => {
    const [data, setData] = useState(channelData);

    return <ChannelContext.Provider value={{contextData: [data, setData] }}>{props.children}</ChannelContext.Provider>
}